import { blend, midi, noteName, pc, pcs } from '../score';

export type Chord = { root: string; cav: readonly string[] };

export const CHORDS: Readonly<Record<string, Chord>> = {
  C: { root: 'C2', cav: ['E4', 'G4', 'C5', 'E5'] },
  C7: { root: 'C2', cav: ['E4', 'G4', 'Bb4', 'C5'] },
  Dm: { root: 'D2', cav: ['D4', 'F4', 'A4', 'D5'] },
  D7: { root: 'D2', cav: ['D4', 'F#4', 'A4', 'C5'] },
  E7: { root: 'E2', cav: ['E4', 'G#4', 'B4', 'D5'] },
  F: { root: 'F2', cav: ['F4', 'A4', 'C5', 'F5'] },
  G7: { root: 'G2', cav: ['D4', 'F4', 'G4', 'B4'] },
  Am: { root: 'A2', cav: ['E4', 'A4', 'C5', 'E5'] },
  A7: { root: 'A2', cav: ['E4', 'G4', 'C#5', 'E5'] },
};

export const MAJOR = [0, 2, 4, 5, 7, 9, 11] as const;

export const PARTIDO = '.X..x.X.X..x..X.';

export const tonesOf = (c: Chord): number[] => pcs([c.root, ...c.cav]);

export function under(note: string, tones: readonly number[]): string {
  const m = midi(note);
  const scale = blend([...MAJOR], tones);
  for (const d of [3, 4]) if (scale.includes(pc(m - d))) return noteName(m - d);
  for (let d = 1; d <= 6; d++) if (tones.includes(pc(m - d))) return noteName(m - d);
  return noteName(m - 3);
}

export function wrap(note: string, lo: number, hi: number): string {
  let m = midi(note);
  while (m < lo) m += 12;
  while (m > hi) m -= 12;
  return noteName(m);
}

export type Stroke = { step: number; vel: number; open: boolean; up: boolean };

export function strokes(pattern: string, ghost: number): Stroke[] {
  const out: Stroke[] = [];
  for (let step = 0; step < 16; step++) {
    const c = pattern[step];
    const open = c === 'X' || c === 'x';
    out.push({ step, vel: c === 'X' ? 1 : c === 'x' ? 0.82 : ghost, open, up: step % 2 === 1 });
  }
  return out;
}
